var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort18Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 10.065H7.19981C6.76481 10.065 6.37106 10.3237 6.20231 10.7212C6.02981 11.1225 6.11231 11.5837 6.41231 11.8987L8.21231 13.7962C8.41481 14.0137 8.70356 14.1375 8.99981 14.1375C9.29606 14.1375 9.58481 14.0137 9.78731 13.8L11.5873 11.9025C11.8873 11.5875 11.9698 11.1262 11.7973 10.725C11.6248 10.3237 11.2348 10.0687 10.7998 10.0687V10.065Z",
    fill: "#ADB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19981 7.93496H10.7998C11.2348 7.93496 11.6286 7.67621 11.7973 7.27871C11.9661 6.88121 11.8873 6.41621 11.5873 6.10121L9.78731 4.20371C9.58106 3.98621 9.29606 3.86621 8.99981 3.86621C8.70356 3.86621 8.41481 3.98996 8.21231 4.20371L6.41231 6.10121C6.11231 6.41621 6.02981 6.88121 6.20231 7.27871C6.37481 7.67996 6.76481 7.93496 7.19981 7.93496Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort18Filled);
export default __webpack_public_path__ + "static/media/icon_sort_18_filled.5c8f01c05275e5468f83a442878fe5a1.svg";
export { ForwardRef as ReactComponent };